import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import FamiliaresView from './FamiliaresView';
import * as ROUTES from '../../../router/Routes';

const FamiliaresModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.familiares}
      routes={[ROUTES.controlEstudios]}
    >
      <FamiliaresView />
    </ContainerTemplate>
  );
};

export default FamiliaresModule;
